import { AGENT_BG, INSTANT_BG, POSTCODE_IMAGES, BASE_URL, POSTCODE_MOB_IMAGES } from '../constants/postcodeImages';

interface Images {
  smallBackground: string;
  largeBackground: string;
}

const getPostcodeImage = (mode: string, postcode?: string): Images => {
  if (postcode) {
    const startCode = postcode.split(' ')[0].toLowerCase();

    if (Object.prototype.hasOwnProperty.hasOwnProperty.call(POSTCODE_IMAGES, startCode)) {
      return {
        smallBackground: `${BASE_URL}${POSTCODE_MOB_IMAGES[startCode]}`,
        largeBackground: `${BASE_URL}${POSTCODE_IMAGES[startCode]}`,
      };
    }
  }

  if (mode === 'agent') {
    return {
      smallBackground: `${BASE_URL}${AGENT_BG}`,
      largeBackground: `${BASE_URL}${AGENT_BG}`,
    };
  }

  return {
    smallBackground: `${BASE_URL}${INSTANT_BG}`,
    largeBackground: `${BASE_URL}${INSTANT_BG}`,
  };
};

export default getPostcodeImage;
